import React from 'react';
import { Link } from "react-router-dom";

import {RtDomainTechnology} from '../../../server/routes/route-types.js'


interface TechnologyVersionData {
    Version?: string;
    TechnologyURL: string;
    Bucket?: number;
    PercentNewerVersion?: number;
}

interface TechnologyVersionWithScoreProps {
    technology: TechnologyVersionData;
    tooltip?: string;
}

function _printRealPercent(percent: number | undefined): string | number | undefined {
    if (undefined === percent) return percent;
    return (percent < 0.1) ? 'less than 0.1' : percent.toFixed(2);
}

export default function TechnologyVersionWithScore({ technology, tooltip }: TechnologyVersionWithScoreProps) {

    if (!technology.Version) return null;

    if (technology.Bucket === 3) {
            if (!tooltip)
            {
                return (<>
                    <b style={{ color: 'green' }} className="fas fa-star"></b>
                    <b style={{ color: 'green' }} className="fas fa-star star-optional"></b>
                    <b style={{ color: 'green' }} className="fas fa-star star-optional"></b>
                    <b style={{ color: 'green' }} className="fas fa-star star-optional"></b>
                </> );                  
            }
            else
            {
                return (
                    <Link 
                        to={`/technology/${technology.TechnologyURL}/version/${technology.Version}`}
                        title={`Only ${_printRealPercent(technology.PercentNewerVersion)}% of websites use a newer version`}
                    >

                        <b style={{ color: 'green' }} className="fas fa-star"></b>
                        <b style={{ color: 'green' }} className="fas fa-star star-optional"></b>
                        <b style={{ color: 'green' }} className="fas fa-star star-optional"></b>
                        <b style={{ color: 'green' }} className="fas fa-star star-optional"></b>
                </Link>)
            }    
    }
    else if (technology.Bucket === 2) {
        if (!tooltip) 
        {
            return (
                <>
                    <b style={{ color: 'greenyellow' }} className="fas fa-star"></b>
                    <b style={{ color: 'greenyellow' }} className="fas fa-star star-optional"></b>
                    <b style={{ color: 'greenyellow' }} className="fas fa-star star-optional"></b>
                    <b style={{ color: 'silver' }} className="fas fa-star star-optional"></b>
                </>
            )    
        }
        else
        {
            return (
                <Link 
                    to={`/technology/${technology.TechnologyURL}/version/${technology.Version}`} 
                    title={`Only ${_printRealPercent(technology.PercentNewerVersion)}% of websites use a newer version`}
                >
                    <b style={{ color: 'greenyellow' }} className="fas fa-star"></b>
                    <b style={{ color: 'greenyellow' }} className="fas fa-star star-optional"></b>
                    <b style={{ color: 'greenyellow' }} className="fas fa-star star-optional"></b>
                    <b style={{ color: 'silver' }} className="fas fa-star star-optional"></b>
                </Link>
            )    
        }
    }
    else if (technology.Bucket === 1) {
        if (!tooltip)
        {
            return (
                <>
                    <b style={{ color: 'orange' }} className="fas fa-star"></b>
                    <b style={{ color: 'orange' }} className="fas fa-star star-optional"></b>
                    <b style={{ color: 'silver' }} className="fas fa-star star-optional"></b>
                    <b style={{ color: 'silver' }} className="fas fa-star star-optional"></b>
                </>
            )    
        }
        else
        {
            return (
                <Link 
                    to={`/technology/${technology.TechnologyURL}/version/${technology.Version}`}
                    title={`${_printRealPercent(technology.PercentNewerVersion)}% of websites use a newer version`}
                >
                    <b style={{ color: 'orange' }} className="fas fa-star"></b>
                    <b style={{ color: 'orange' }} className="fas fa-star star-optional"></b>
                    <b style={{ color: 'silver' }} className="fas fa-star star-optional"></b>
                    <b style={{ color: 'silver' }} className="fas fa-star star-optional"></b>
                </Link>
            )    
        }
    }
    else if (technology.Bucket === 0) {
        if (!tooltip)
        {
            return (
                <>
                    <b style={{ color: 'red' }} className="fas fa-star"></b>
                    <b style={{ color: 'silver' }} className="fas fa-star star-optional"></b>
                    <b style={{ color: 'silver' }} className="fas fa-star star-optional"></b>
                    <b style={{ color: 'silver' }} className="fas fa-star star-optional"></b>
                </>            
            )    
        }
        else
        {
            return (
                <Link 
                    to={`/technology/${technology.TechnologyURL}/version/${technology.Version}`} 
                    title={`${_printRealPercent(technology.PercentNewerVersion)}% of websites use a newer version`}
                >
                    <b style={{ color: 'red' }} className="fas fa-star"></b>
                    <b style={{ color: 'silver' }} className="fas fa-star star-optional"></b>
                    <b style={{ color: 'silver' }} className="fas fa-star star-optional"></b>
                    <b style={{ color: 'silver' }} className="fas fa-star star-optional"></b>
                </Link>            
            )    
        }
    }

    return (<></>);
}

/*
function ColoredVersionLink({left,right,url,version,percent})
{
    return (
        <Link 
            to={`/technology/${url}/version/${version}`} 
            title={`${_printRealPercent(percent)}% of websites use a newer version`}
        >
            <b style={{color:`${left}`}} className="fas fa-star"></b>
            <b style={{color:`${right}`}} className="fas fa-star star-optional"></b>
            <b style={{color:`${right}`}} className="fas fa-star star-optional"></b>
            <b style={{color:`${right}`}} className="fas fa-star star-optional"></b>
        </Link>
    )
}*/